import usersIcon from './icons/person.png'
import dogsIcon from './icons/dog-barking-outline.png'
import addIcon from './icons/add-circle-outline.png'
import postIcon from './icons/photo-outline.png'
import { Link } from "react-router-dom"

export const RightPane = () => {
    return (
        <div className="col-sm-10 brand-yellow-border-bottom
        align-items-center justify-content-center h-100" style={{
                height
                    : "100vh"
            }}>
            <div className="row justify-content-center align-items-center my-5">
                <img src={postIcon} />

                <span><Link to='/community/posts'>Share a post</Link></span>
            </div>

            <div className="row justify-content-center align-items-center mb-5">
                <img src={addIcon} />

                <span><Link to='/dog_registrations_special/1'>New dog</Link></span>
            </div>
        </div>
    )
}